<template>
  <property-form @submit="add" />
</template>

<script>
import { db, getUid } from '@/plugins/firebase';
import PropertyForm from './PropertyForm.vue';

export default {
  name: 'AddProperty',
  components: { PropertyForm },
  methods: {
    async add(property) {
      await db
        .collection('properties')
        .add({ ...property, admin: getUid() });
      this.$router.push('properties');
    },
  },
};
</script>

<style></style>
